export const namespaceAndFieldNameRegex = /^[a-zA-Z]([a-zA-Z0-9-_$.])*$/;
